import server from "./server";

export const getSettingsApi = async () => {
  const response = await server().get("/settings");
  return response.data;
};

export const editSettingsApi = async ({ data, id }) => {
  const response = await server().put(`/settings/${id}`, data);
  return response.data;
};
